import { createRoot } from 'react-dom/client'
import App from './pages/App'
import { ThemeProvider } from '@mui/material/styles'
import { BrowserRouter } from 'react-router'
import CssBaseline from '@mui/material/CssBaseline'
import ErrorBoundary from './components/ErrorBoundary'
import Error from './pages/Error'
import initFirebase from './db/initFirebase'

// material ui theme
import theme from './theme'

// fonts - material ui was built with roboto in mind
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

// some global css
import './index.css'

initFirebase()

const root = createRoot(document.getElementById('root')!)

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <ErrorBoundary onError={console.log} errorComponent={<Error />}>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </ThemeProvider>
)
